// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Checkbox } from 'informed';

import {
  addDietHistory,
  deleteDietHistory,
  updateDietHistory,
} from '../../../actions/informationHistoryActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';

type Props = {
  dob: string,
  dietHistory: Object[],
  activePatientId: string,
  addDietHistory: Function,
  deleteDietHistory: Function,
  updateDietHistory: Function,
}

class DietHistoryComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.from = moment(formValues.from, 'DD-MM-YYYY').toISOString();
    formValues.to = moment(formValues.to, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteDietHistory(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateDietHistory(this.props.activePatientId, {
      dietHistoryId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addDietHistory(this.props.activePatientId, formData.values);
  }

  render() {
    const { dietHistory } = this.props;

    const columns = [
      {
        Header: 'From',
        id: 'from',
        cell: item => (item.from ? moment(item.from).format() : '--'),
        editCell: item => <DateText field='from' item={item} />,
      },
      {
        Header: 'To',
        id: 'to',
        cell: item => (item.to ? moment(item.to).format() : '(ongoing)'),
        editCell: item => <DateText field='to' item={item} nullable />,
      },
      {
        Header: 'Extra snack',
        id: 'extraSnack',
        cell: item => (item.extraSnack ? '✓' : '--'),
        editCell: item => <Checkbox field='extraSnack' initialValue={item.extraSnack} />,
      },
      {
        Header: 'On Jonathan diet (high-protein)',
        id: 'highCalDiet',
        cell: item => (item.highCalDiet ? '✓' : '--'),
        editCell: item => <Checkbox field='highCalDiet' initialValue={item.highCalDiet} />,
      },
    ];

    return (
      <Table
        columns={columns}
        data={dietHistory}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  dob: state.patient.data.generalInfo.dob,
  dietHistory: state.patient.data.dietHistory,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addDietHistory:
    (patientId, dietHistory) => dispatch(addDietHistory(patientId, dietHistory)),
  deleteDietHistory:
    (patientId, dietHistoryId) => dispatch(deleteDietHistory(patientId, dietHistoryId)),
  updateDietHistory:
    (patientId, dietHistory) => dispatch(updateDietHistory(patientId, dietHistory)),
});

const DietHistory = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DietHistoryComponent);

export default DietHistory;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/informationHistory/DietHistory.jsx